import axiosInstance from "./axiosInstance";
import {
  CreateLeaveTypePayload,
  UpdateLeaveTypePayload,
  LeaveTypeConfigFilters,
  LeaveTypeSearchResponse,
} from "types/leaveTypeMaster";

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getLeaveTypeMaster = async (
  filters: LeaveTypeConfigFilters = {},
) => {
  try {
    const response = await axiosInstance.get("/leave-type-master", {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getLeaveTypeList = async (
  filters: LeaveTypeConfigFilters = {},
) => {
  try {
    const response = await axiosInstance.get<LeaveTypeSearchResponse>(
      "/hr/settings/leave-types/search",
      {
        params: {
          PageNumber: filters.pageNo ?? 1,
          PageSize: filters.pageSize ?? 20,
          LeaveName:
            filters.name ||
            filters.searchTerm ||
            filters.leaveTypeName ||
            undefined,
          LeaveCode: filters.leaveCode || undefined,
          IsPaidLeave:
            !filters.paidLeave || filters.paidLeave === "all"
              ? undefined
              : filters.paidLeave === "paid",
          RequiresAttachment:
            !filters.requiresAttachment || filters.requiresAttachment === "all"
              ? undefined
              : filters.requiresAttachment === "true",
          RequiresApproval:
            !filters.requiresApproval || filters.requiresApproval === "all"
              ? undefined
              : filters.requiresApproval === "true",
          IsHalfDayAllowed:
            !filters.halfDayAllowed || filters.halfDayAllowed === "all"
              ? undefined
              : filters.halfDayAllowed === "true",
          IsCarryForwardAllowed:
            !filters.carryForward || filters.carryForward === "all"
              ? undefined
              : filters.carryForward === "true",
          IsEncashable:
            !filters.encashable || filters.encashable === "all"
              ? undefined
              : filters.encashable === "true",
          MinimumServiceRequired: filters.minimumServiceRequired?.trim()
            ? Number(filters.minimumServiceRequired)
            : undefined,
          IsActive:
            !filters.status || filters.status === "all"
              ? undefined
              : filters.status === "active",
        },
        headers: {
          ...getAuthHeader(),
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createLeaveType = async (payload: CreateLeaveTypePayload) => {
  try {
    const response = await axiosInstance.post(
      "/hr/settings/leave-types",
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLeaveType = async (
  publicId: string,
  payload: UpdateLeaveTypePayload,
) => {
  try {
    const response = await axiosInstance.put(
      `/hr/settings/leave-types/${encodeURIComponent(publicId)}`,
      payload,
      {
        headers: {
          ...getAuthHeader(),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteLeaveType = async (publicId: string): Promise<void> => {
  await axiosInstance.delete(
    `/hr/settings/leave-types/${encodeURIComponent(publicId)}`,
    {
      headers: {
        ...getAuthHeader(),
      },
    },
  );
};
